<template>
    <el-drawer
        title="成员详情"
        :close-on-press-escape="false"
        :visible.sync="drawer">
        <span slot="title" class="font14px text-bold">成员详情</span>
        <div class="p20">
            <el-form label-width="150px" label-position="top">
                <el-form-item label="姓名：" v-if="fields.includes('name')">
                    <span class="mr10">{{userInfo.name||'--'}}</span>
                    <span class="text-color-success" title="微信已绑定" v-if="userInfo.is_bind_wx=='1'">
                        <i class="iconfont icon-jt-wechat-fill vertical-bottom"></i>
                    </span>
                </el-form-item>
                <el-form-item label="ID：">
                    <span>{{id}}</span>
                </el-form-item>
                <el-form-item label="企微ID：">
                    <span>{{userInfo.wework_uid || '--'}}</span>
                </el-form-item>
                <el-form-item label="启用状态：">
                    <span>{{getStatusText(userInfo.status)}}</span>
                </el-form-item>
                <el-form-item label="在职状态：">
                    <span>{{getUserStatusText(userInfo.user_status)}}</span>
                </el-form-item>
                <el-form-item label="手机号：" v-if="fields.includes('mobile')">
                    <span>{{userInfo.mobile||'--'}}</span>
                </el-form-item>
                <el-form-item label="邮箱：" v-if="fields.includes('email')">
                    <span>{{userInfo.email||'--'}}</span>
                </el-form-item>
                <el-form-item label="角色：" v-if="fields.includes('role_name')">
                    <span>{{userInfo.role_name||'--'}}</span>
                </el-form-item>
                <el-form-item label="部门：" v-if="fields.includes('group_name')">
                    <span>{{userInfo.group_name_with_parent||'--'}}</span>
                </el-form-item>
                <el-form-item label="部门数据权限：" v-if="fields.includes('user_data_action')">
                    <span>{{userInfo.user_data_action||'--'}}</span>
                </el-form-item>
                <el-form-item label="创建时间：" v-if="fields.includes('create_time')">
                    <span>{{userInfo.create_time||'--'}}</span>
                </el-form-item>
                <el-form-item label="最近编辑时间与编辑人：">
                    <p>{{userInfo.edit_time}}（{{userInfo.editor}}-{{userInfo.log_type}}）</p>
                </el-form-item>
                <el-form-item label="备注：">
                    <span>{{userInfo.note||'--'}}</span>
                </el-form-item>
            </el-form>
        </div>
    </el-drawer>
</template>

<script>
    import API from '@/api/department.js';

    export default {
        name: "UserInfoDrawer",
        props:{
            id:{
                required:true,
                type:[Number,String, Array],
            },
            func:{
                type:Array,
                required:true,
            },
            fields:{
                type:Array,
                required:true,
            },
        },
        data(){
            return{
                drawer:false,
                userInfo:{
                    name:'',
                    is_bind_wx:'',
                    mobile:'',
                    email:'',
                    role_name:'',
                    group_name_with_parent:'',
                    create_time:'',
                    log_lists:[],
                    note:'',
                    user_data_action:'',
                    edit_time:'',
                    editor:'',
                    log_type:'',
                    status:'',
                    user_status:'',
                    wework_uid: ''
                },
            }
        },
        methods:{
            showDrawer(){
                this.drawer = true;
                this.$nextTick(()=>{
                    this.getUserInfo();
                })
            },
            getUserInfo(){
                API.getUserInfo({
                    id: this.id,
                }).then(res => {
                    let resData = res.data||{};
                    this.userInfo.name=resData.name;
                    this.userInfo.is_bind_wx=resData.is_bind_wx;
                    this.userInfo.mobile=resData.mobile;
                    this.userInfo.email=resData.email;
                    this.userInfo.role_name=resData.role_name;
                    this.userInfo.group_name_with_parent=resData.group_name_with_parent;
                    this.userInfo.user_data_action=resData.user_data_action;
                    this.userInfo.create_time=resData.create_time;
                    this.userInfo.log_lists=resData.log_lists;
                    this.userInfo.note=resData.note;
                    this.userInfo.edit_time=resData.edit_time;
                    this.userInfo.editor=resData.editor;
                    this.userInfo.log_type=resData.log_type;
                    this.userInfo.status=resData.status;
                    this.userInfo.user_status=resData.user_status;
                    this.userInfo.wework_uid=resData.wework_uid;
                }, (err) => {
                    console.log('getUserInfo error', err);
                    this.userInfo = {
                        name:'',
                        bind_wx:'',
                        mobile:'',
                        email:'',
                        role_name:'',
                        group_name_with_parent:'',
                        create_time:'',
                        log_lists:[],
                        note:'',
                        user_data_action:'',
                        edit_time: '',
                        editor: '',
                        log_type: '',
                        status:'',
                        user_status:'',
                        wework_uid: ''
                    };
                });
            },
            getStatusText(val){
                if(!val) return '-';
                if(val=='1') return '启用';
                if(val=='0') return '禁用';
                return val;
            },
            getUserStatusText(val){
                if(!val) return '-';
                if(val=='1') return '在职';
                if(val=='2') return '离职';
                if(val=='0') return '无状态';
                return val;
            }
        }
    }
</script>

<style scoped>
    ::v-deep .el-drawer__header{
        padding: 15px 20px;
        margin: 0;
        border-bottom: solid 1px #dcdee2;
    }

    ::v-deep .el-form-item__label{
        line-height: 24px;
        padding-bottom: 0;
        padding-left: 15px;
    }
    ::v-deep .el-form-item__content{
        line-height: 24px;
        padding-bottom: 0;
        padding-left: 20px;
    }

</style>
